<template>
  <el-tabs v-model="card_index" @tab-click="handleClick">
    <el-tab-pane label="收费标准设置" name="MeterOrderPrice">
      <MeterOrderPrice v-if="card_index === 'MeterOrderPrice'" />
    </el-tab-pane>
    <el-tab-pane label="仪表单价设置" name="MeterOrderItemPrice">
      <MeterOrderItemPrice v-if="card_index === 'MeterOrderItemPrice'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import MeterOrderPrice from "./MeterOrderPrice";
import MeterOrderItemPrice from "./MeterOrderItemPrice";
export default {
  name: "MeterOrderPriceMain",
  components: {MeterOrderItemPrice, MeterOrderPrice},
  data() {
    return {
      card_index: "MeterOrderPrice"
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderPriceMain.vue